
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("gSGR3", function(module, exports) {

$parcel$export(module.exports, "DashboardsContentViewQuery", () => $7d8146b84d35c151$export$bf90b08b5380f35c);

var $azFkr = parcelRequire("azFkr");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2tacr = parcelRequire("2tacr");
function $7d8146b84d35c151$export$bf90b08b5380f35c({ queries: { queryRef: queryRef } }) {
    const data = (0, $8Uumt.usePreloadedQuery)((0, $azFkr.default), queryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tacr.DashboardsContent), {
        queryRef: data
    });
}

});
parcelRegister("azFkr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc04cf6edfa8673b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<76cb6444f1372f8646d016b4de6cea5d>>
 * @relayHash 9a58486151638f4e45660f746394b248
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 187971dfb7440b89eb5a98f67e766ec91b921dc8dd450612125a7211123e347d

var $eiowN = parcelRequire("eiowN");
const $bc04cf6edfa8673b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "dashboardId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v2 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraDashboard"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v2 /*: any*/ 
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                }
            ]
        }
    ], v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "DashboardsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "DashboardsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "DashboardsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "dashboardFavourites",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "DASHBOARD"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v3 /*: any*/ 
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "dashboardRecents",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "DASHBOARD"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v3 /*: any*/ 
                                },
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "187971dfb7440b89eb5a98f67e766ec91b921dc8dd450612125a7211123e347d",
            "metadata": {},
            "name": "DashboardsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bc04cf6edfa8673b$var$node.hash = "2a6d30dd0ebce8d8b8a64e7710f0879f";
(0, $eiowN.PreloadableQueryRegistry).set($bc04cf6edfa8673b$var$node.params.id, $bc04cf6edfa8673b$var$node);
var $bc04cf6edfa8673b$export$2e2bcd8739ae039 = $bc04cf6edfa8673b$var$node;

});

parcelRegister("2tacr", function(module, exports) {

$parcel$export(module.exports, "DashboardsContent", () => $980b1272be7fd89e$export$439bb78193b2b442);

var $g1V1N = parcelRequire("g1V1N");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $9Gyp5 = parcelRequire("9Gyp5");

var $5FnJJ = parcelRequire("5FnJJ");

var $gxbcq = parcelRequire("gxbcq");

var $1b6zA = parcelRequire("1b6zA");

var $hjTAj = parcelRequire("hjTAj");

var $afcwS = parcelRequire("afcwS");

var $iE0sN = parcelRequire("iE0sN");

var $koeKL = parcelRequire("koeKL");

var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");
var $2CQvU = parcelRequire("2CQvU");

var $1deEY = parcelRequire("1deEY");
const $980b1272be7fd89e$var$MAX_RECENT_PROJECTS = 5;
const $980b1272be7fd89e$var$MAX_FAVORITE_PROJECTS = 15;
const $980b1272be7fd89e$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
function $980b1272be7fd89e$export$439bb78193b2b442({ queryRef: queryRef }) {
    const cloudId = (0, $koeKL.useCloudId)();
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const { getStableItems: getStableItems } = (0, $1b6zA.useStableItems)();
    // https://jplat.jira.atlassian.cloud/browse/BLU-2719
    // We intentionally request 15 starred and 20 recent dashboards.
    // Then, if all 10 starred dashboards were recently visited, we still show 5 recent dashboards as well.
    const [{ jira: { dashboardFavourites: dashboardFavourites, dashboardRecents: dashboardRecents } }, refetch] = (0, $8Uumt.useRefetchableFragment)((0, $g1V1N.default), queryRef);
    (0, $9Gyp5.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $iE0sN.default,
        refetch: refetch,
        menuId: (0, $jhS4y.MENU_ID_DASHBOARDS)
    });
    const refetchOnChange = (0, $5uXOq.useCallback)(({ onComplete: onComplete })=>{
        refetch({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        cloudId,
        refetch
    ]);
    (0, $gxbcq.useSubscribeAndUpdateFavorites)({
        entityTypename: 'JiraDashboard',
        favouriteConnectionId: dashboardFavourites.__id,
        recentConnectionId: dashboardRecents.__id,
        refetch: refetchOnChange
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const starred = formatMessage((0, $1deEY.default).starred);
    const recent = formatMessage((0, $1deEY.default).recent);
    const favorites = (0, $5uXOq.useMemo)(()=>{
        const ids = dashboardFavourites.edges?.map((edge)=>edge?.node.id).filter(Boolean) ?? [];
        const list = dashboardFavourites.edges?.filter(Boolean).map((edge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjTAj.DashboardMenuItem), {
                key: edge.node.dashboardId,
                queryRef: edge.node
            })) ?? [];
        return {
            idSet: new Set(ids),
            list: list.slice(0, $980b1272be7fd89e$var$MAX_FAVORITE_PROJECTS),
            hasItems: Boolean(list.length),
            hasNextPage: dashboardFavourites?.pageInfo?.hasNextPage || list.length > $980b1272be7fd89e$var$MAX_FAVORITE_PROJECTS
        };
    }, [
        dashboardFavourites
    ]);
    const recentItems = (0, $5uXOq.useMemo)(()=>{
        const nodes = dashboardRecents.edges?.filter(Boolean).filter((edge)=>edge.node.id && !favorites.idSet.has(edge.node.id)).map((edge)=>edge.node).slice(0, $980b1272be7fd89e$var$MAX_RECENT_PROJECTS) || [];
        const stableOrderedNodes = getStableItems({
            nodes: nodes,
            idKey: 'id'
        });
        const list = stableOrderedNodes.map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjTAj.DashboardMenuItem), {
                key: node.dashboardId,
                queryRef: node
            }));
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        dashboardRecents.edges,
        favorites.idSet,
        getStableItems
    ]);
    if (!favorites.hasItems && !recentItems.hasItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $afcwS.DashboardsEmptyContent), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CQvU.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, favorites.list))), favorites.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        href: $980b1272be7fd89e$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $jhS4y.MENU_ID_DASHBOARDS_VIEW_ALL_STARRED)
    }, formatMessage((0, $1deEY.default).viewAllStarred))), recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CQvU.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, recentItems.list))));
}

});
parcelRegister("g1V1N", function(module, exports) {

$parcel$export(module.exports, "default", () => $c69b9c9d27d137b1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11ee00a8f92b503876d9bf6eeff66af8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $iE0sN = parcelRequire("iE0sN");
const $c69b9c9d27d137b1$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "dashboardId"
    }, v3 = {
        "kind": "FragmentSpread",
        "name": "DashboardMenuItem"
    }, v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $iE0sN.default)
            }
        },
        "name": "DashboardsContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "dashboardFavourites",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "DASHBOARD"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.dashboardFavourites.edges.node.id"
                                                                },
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraDashboard"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.dashboardFavourites.edges.node"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.dashboardFavourites"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "dashboardRecents",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "currentURL",
                                        "variableName": "currentURL"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "DASHBOARD"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.dashboardRecents.edges.node.id"
                                                                },
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraDashboard"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.dashboardRecents.edges.node"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.dashboardRecents"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$c69b9c9d27d137b1$var$node.hash = "2efc6b73165a1bbb92f1953043700da4";
var $c69b9c9d27d137b1$export$2e2bcd8739ae039 = $c69b9c9d27d137b1$var$node;

});
parcelRegister("iE0sN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8cd54efc44d623a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<be6f5993018a343b4acafe0061e2e04e>>
 * @relayHash abf151795028f3770a9300523a04af00
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ae80ab59ee2189cebc2881d3c421bf61d0f5f6840817cb3dddfaff62c6677a31
const $d8cd54efc44d623a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "dashboardId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraDashboard"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v3 /*: any*/ 
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                }
            ]
        }
    ], v5 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4DashboardsContentQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "DashboardsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4DashboardsContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "dashboardFavourites",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "DASHBOARD"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v4 /*: any*/ 
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "dashboardRecents",
                            "args": [
                                v2 /*: any*/ ,
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "DASHBOARD"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v4 /*: any*/ 
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ae80ab59ee2189cebc2881d3c421bf61d0f5f6840817cb3dddfaff62c6677a31",
            "metadata": {},
            "name": "Nav4DashboardsContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d8cd54efc44d623a$var$node.hash = "2efc6b73165a1bbb92f1953043700da4";
var $d8cd54efc44d623a$export$2e2bcd8739ae039 = $d8cd54efc44d623a$var$node;

});


parcelRegister("hjTAj", function(module, exports) {

$parcel$export(module.exports, "DashboardMenuItem", () => $06188daec5d0ea0c$export$5c7baf31dfb5503f);

var $cRPrh = parcelRequire("cRPrh");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gsyzJ = parcelRequire("gsyzJ");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $6MFxN = parcelRequire("6MFxN");

var $gxw5a = parcelRequire("gxw5a");
function $06188daec5d0ea0c$export$5c7baf31dfb5503f({ queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $cRPrh.default), queryRef);
    const { fireUIAnalyticForDashboardItems: fireUIAnalyticForDashboardItems } = (0, $5uXOq.useContext)((0, $6MFxN.AnalyticContext));
    if (!data) return null;
    const dashboardUrl = `/jira/dashboards/${data.dashboardId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        href: dashboardUrl,
        menuId: (0, $jhS4y.ENTITY_ID).DASHBOARD(String(data.dashboardId)),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxw5a.DashboardPopupMenu), {
            dashboardData: data
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gsyzJ))), {
            label: "",
            color: "currentColor"
        }),
        onClick: ()=>{
            fireUIAnalyticForDashboardItems({
                itemId: String(data.dashboardId),
                section: data?.favouriteValue?.isFavourite ? (0, $jecJ3.SECTION_ITEM_STARRED) : (0, $jecJ3.SECTION_ITEM_RECENT)
            });
        }
    }, data.title);
}

});
parcelRegister("cRPrh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b406664bb6832059$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b252365ea6f4033de11ad3ac85b26fb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b406664bb6832059$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DashboardMenuItem",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "title"
            },
            "action": "THROW",
            "path": "title"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "dashboardId"
            },
            "action": "THROW",
            "path": "dashboardId"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "DashboardPopupMenu"
        }
    ],
    "type": "JiraDashboard"
};
$b406664bb6832059$var$node.hash = "e30b21c7949d8052bd6833da91711e25";
var $b406664bb6832059$export$2e2bcd8739ae039 = $b406664bb6832059$var$node;

});

parcelRegister("gxw5a", function(module, exports) {

$parcel$export(module.exports, "DashboardPopupMenu", () => $5f374019177db79e$export$4fdb1267041f7bae);

var $1R0Yj = parcelRequire("1R0Yj");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $bUmQV = parcelRequire("bUmQV");


var $d62in = parcelRequire("d62in");

var $aCS3f = parcelRequire("aCS3f");

var $gSZmd = parcelRequire("gSZmd");


var $6MFxN = parcelRequire("6MFxN");
const $5f374019177db79e$export$4fdb1267041f7bae = ({ dashboardData: dashboardData })=>{
    const data = (0, $8Uumt.useFragment)((0, $1R0Yj.default), dashboardData);
    const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton, fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle } = (0, $5uXOq.useContext)((0, $6MFxN.AnalyticContext));
    const MenuItems = (0, $5uXOq.useCallback)(()=>{
        const { id: id, dashboardId: dashboardId } = data;
        const isFavourite = Boolean(data?.favouriteValue?.isFavourite);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d62in.FavoriteToggleButton), {
            entityId: id,
            defaultIsStarred: isFavourite,
            entityTypeName: "JiraDashboard",
            onClick: ()=>{
                fireUIAnalyticForFavouriteToggle({
                    starType: isFavourite ? (0, $ac13fa3c12e20c46$export$5fe513938f2c4081) : (0, $ac13fa3c12e20c46$export$54408be40394d82a),
                    parentItemId: String(dashboardId)
                });
            }
        }));
    }, [
        data,
        fireUIAnalyticForFavouriteToggle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        gap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: ()=>fireUIAnalyticForFixButton({
                itemId: (0, $ddbe4b334e21c7a1$export$f06dfcec5ff912e)
            }),
        MenuItems: MenuItems
    }));
};

});
parcelRegister("1R0Yj", function(module, exports) {

$parcel$export(module.exports, "default", () => $685d08f08d398300$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36e17dcd5ce3ff2971120c2bb95528a0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $685d08f08d398300$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DashboardPopupMenu",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "dashboardId"
            },
            "action": "THROW",
            "path": "dashboardId"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                }
            ]
        }
    ],
    "type": "JiraDashboard"
};
$685d08f08d398300$var$node.hash = "a386558bb17b8fafc916eb203a4d28ee";
var $685d08f08d398300$export$2e2bcd8739ae039 = $685d08f08d398300$var$node;

});

const $ac13fa3c12e20c46$export$54408be40394d82a = 'star';
const $ac13fa3c12e20c46$export$5fe513938f2c4081 = 'unstar';

const $ddbe4b334e21c7a1$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Dashboards';
const $ddbe4b334e21c7a1$export$d57b6b390e78d90f = 'jira-cosmos';
const $ddbe4b334e21c7a1$export$65b778215f917c60 = 'viewAllDashboards';
const $ddbe4b334e21c7a1$export$7be02fe416808d26 = 'createDashboard';
const $ddbe4b334e21c7a1$export$f06dfcec5ff912e = 'meatballDropdown';



parcelRegister("afcwS", function(module, exports) {

$parcel$export(module.exports, "DashboardsEmptyContent", () => $d52cc5a7a03724c3$export$54678b9782e1c19b);

var $5uXOq = parcelRequire("5uXOq");

var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $7lgBG = parcelRequire("7lgBG");

var $8Rqp2 = parcelRequire("8Rqp2");
function $d52cc5a7a03724c3$export$54678b9782e1c19b() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7lgBG.EmptyContentMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $8Rqp2.default).emptyDashboardsMessage)));
}

});
parcelRegister("8Rqp2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff6bfea929fd13b7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ff6bfea929fd13b7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyDashboardsMessage: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.empty-content.empty-dashboards-message",
        "defaultMessage": "Once you visit or create dashboards, they\u2019ll show up here."
    }
});

});


parcelRegister("1deEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8574efbecd63d724$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8574efbecd63d724$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.starred",
        "defaultMessage": "Starred"
    },
    viewAllStarred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.view-all-starred",
        "defaultMessage": "View all starred"
    }
});

});




//# sourceMappingURL=nav4-dashboards-content-entry-point.6bc18eb8.js.map
